export const ERROR_MOMENT_MESSAGE =
	'https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md';
